import { render } from "./GetInTouch.vue?vue&type=template&id=0635bc70&scoped=true&bindings={\"v$\":\"setup\",\"name\":\"data\",\"email\":\"data\",\"subject\":\"data\",\"message\":\"data\",\"submitted\":\"data\",\"handleSubmit\":\"options\",\"encode\":\"options\",\"messageFor\":\"options\"}"
import script from "./GetInTouch.vue?vue&type=script&lang=js"
export * from "./GetInTouch.vue?vue&type=script&lang=js"

import "./GetInTouch.vue?vue&type=style&index=0&id=0635bc70&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0635bc70"

export default script